/** A 24-hour time as two native selects. `type="time"` follows the browser's
 * locale and can show am/pm, so it cannot promise 24-hour. Minutes step by
 * five, but a stored off-step minute stays selectable so an edit keeps it. */
import { SELECT_CLASS } from './scheduleForm';

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'));
const STEP_MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'));

export function TimeSelects({ value, onChange }: { value: string; onChange: (time: string) => void }) {
  const [hour = '08', minute = '00'] = value.split(':');
  const minutes = STEP_MINUTES.includes(minute) ? STEP_MINUTES : [...STEP_MINUTES, minute].sort();
  return (
    <div className="flex items-center gap-2">
      <select aria-label="Hour" className={`${SELECT_CLASS} w-20`} value={hour} onChange={(e) => onChange(`${e.target.value}:${minute}`)}>
        {HOURS.map((h) => <option key={h} value={h}>{h}</option>)}
      </select>
      <span aria-hidden>:</span>
      <select aria-label="Minute" className={`${SELECT_CLASS} w-20`} value={minute} onChange={(e) => onChange(`${hour}:${e.target.value}`)}>
        {minutes.map((m) => <option key={m} value={m}>{m}</option>)}
      </select>
    </div>
  );
}
